import { get } from 'lodash';
import * as Sentry from '@sentry/browser';
import { userStore } from 'stores';
import { networkErrorMessages } from './constants';

/* eslint-disable import/prefer-default-export */
export const getServerErrorMessage = errorObject => {
  const errorMessage = get(
    errorObject,
    'response.data.error.message',
    networkErrorMessages.serverDown,
  );

  return errorMessage;
};
/* eslint-enable import/prefer-default-export */

export const handleServiceError = e => {
  Sentry.withScope(scope => {
    scope.setExtra('status', e.status);
    scope.setExtra('errorInfo', e.errors);
    scope.setExtra('message', e.message);

    const { userData } = userStore;
    if (userData && userData?.login) {
      scope.setUser({ username: userData.login });
    }

    Sentry.captureException(e);
  });
};
